import React from "react";
import experienceData from "../../config/experience";
import messages from "./experience.messages";
import ContentCard from "../../components/content/ContentCard";
import { getNewestFirstItems } from "../../utils/content";

export default function Experience() {
  const experience = getNewestFirstItems(experienceData);

  return (
    <section className="p-4">
      <h2 className="content-anim text-4xl md:text-5xl mb-6" style={{ "--content-delay": "80ms" }}>
        {messages.heading}
      </h2>

      <div className="flex flex-col gap-3">
        {experience.map((item, index) => (
          <div key={item.slug} className="content-list-item-anim w-full" style={{ "--item-delay": `${170 + index * 70}ms` }}>
            <ContentCard item={item} to={`/experience/${item.slug}`} />
          </div>
        ))}
      </div>
    </section>
  );
}